import React from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { ChannelDisconnectionEvent } from 'common/core/constants/ChannelDisconnectionEvents'
import { ChannelType } from 'common/core/constants/ChannelType'
import { PermissionType } from 'common/core/hooks/permissions/types'
import { useGetPermissionHref } from 'common/core/hooks/permissions/useGetPermissionHref'
import { getInstagramBannerAction } from 'common/core/lib/refreshPermissions'
import { getRefreshPermissionsData } from 'common/core/selectors/refreshPermissionsSelectors'
import { useDidMountEffect } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const InstagramPageConnectionLost = () => {
  const refreshPermissionsData = useAppSelector(getRefreshPermissionsData)
  const action = getInstagramBannerAction(refreshPermissionsData)
  const { getPermissionHref } = useGetPermissionHref()
  const url = getPermissionHref(
    action?.permissionType ?? PermissionType.INSTAGRAM_PERMISSIONS,
    window.location.href,
  )

  useDidMountEffect(() => {
    if (!action) return

    analyticsService.sendEvent(ChannelDisconnectionEvent.BANNER_SHOWN, {
      channel: ChannelType.INSTAGRAM,
    })
  })

  const handleRefresh = () => {
    analyticsService.sendEvent('IG_REFRESH_ADMIN_PERMISSIONS_BANNER.CLICKED')
  }

  if (!action) return null

  return (
    <>
      <span>
        {l.translate(
          'Instagram channel lost connection with this account. Instagram page admin needs to <l10n context="Refresh Permissions" />',
        )}
      </span>
      <a href={url} onClick={handleRefresh} className={cx(cm.more, 'm-l-xxs')}>
        {l.translate('Refresh Permissions')}
      </a>
    </>
  )
}
